import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/Button';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/1HY3DSYVqG3SwFku6ZfET4/c5c1e3c7-73c4-412d-b100-eab77e25f3ef.png';
export function FinalCTA() {
  return <section className="py-24 relative z-10 bg-mystic-800/80 border-t border-gold/20 overflow-hidden" data-id="element-121">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold/10 via-mystic-900 to-mystic-900" data-id="element-122"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-123">
        <div className="max-w-5xl mx-auto text-center" data-id="element-124">
          <motion.h2 initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-4xl md:text-6xl font-bold text-white mb-12" data-id="element-125">
            Comenzá hoy tu formación <br className="hidden md:block" data-id="element-126" />
            <span className="text-gold" data-id="element-127">profesional en Tarot</span>
          </motion.h2>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-12 text-left" data-id="element-128">
            <motion.div initial={{
            scale: 0.96
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} className="relative flex items-center justify-center" data-id="element-129">
              <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(202,162,74,0.14),_transparent_65%)] rounded-full" data-id="element-130"></div>
              <img src={MOCKUP_URL} alt="MegaPack Tarot Profesional: caja, tomos, tablet, celular y cartas" loading="lazy" decoding="async" className="relative w-full max-w-md object-contain drop-shadow-2xl" data-id="element-131" />
            </motion.div>

            <motion.div initial={{
            x: 20
          }} whileInView={{
            x: 0
          }} viewport={{
            once: true
          }} className="space-y-8" data-id="element-132">
              <div className="grid grid-cols-2 gap-4" data-id="element-133">
                {['12 Tomos', '3 Bonos', 'Manual Profesional', 'Tarot Evolutivo', 'Certificado', 'Acceso inmediato', 'Acceso de por vida'].map((benefit, i) => <div key={i} className="flex items-center gap-2 text-white/90 font-medium" data-id="element-134">
                    <CheckCircle2 size={18} className="text-gold flex-shrink-0" data-id="element-135" />
                    <span data-id="element-136">{benefit}</span>
                  </div>)}
              </div>

              <Button href="#pricing" size="lg" className="w-full text-lg py-5 shadow-gold-lg" data-id="element-137">
                QUIERO ACCEDER AHORA
              </Button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}